import Index from './pages/index.vue';

export const FeedbackSurveyRoutes: import('vue-router').RouteConfig[] = [
	{
		path: '/feedback',
		component: () => import('./pages/master.vue').then((m) => m.default),
		children: [
			{ path: `success`, component: () => import('./pages/success.vue').then((m) => m.default), },
			{ path: `unsuccessful`, component: () => import('./pages/unsuccessful.vue').then((m) => m.default), },
			{ path: '', component: Index, },
		],
	},
];
